import { FC, useCallback } from "react";

import { ApplicationInspection } from "../../modules/core/applications";
import { ShowDateCell } from "./ShowDateCell";
import { KTSVG } from "../../../_metronic/helpers";

import { ApplicationFileDownload } from "./ApplicationFileDownload";
import { useAuth } from "../../modules/auth";
import { useInspectionReuploadModalState } from "../../modules/setsco/workflow/inspection-reupload-modal/InspectionReuploadModal";
import { isPopulatedArray } from "../helpers";

type Props = {
  inspection: ApplicationInspection
}

export const InspectionCard: FC<Props> = ({inspection}) => {
  const { hasRole } = useAuth();
  const { setData, toggleShow } = useInspectionReuploadModalState(state => state);

  const onClickReupload = useCallback(() => {
    setData(inspection);
    toggleShow(true);
  // eslint-disable-next-line
  }, [inspection]);


  return (
  <div className={'d-flex flex-row align-items-center rounded px-4 py-2 mb-7 ' + (inspection.approved ? 'bg-light-success': 'bg-light-danger')}>
    <span className='svg-icon svg-icon-warning me-5'>
      { inspection.approved ? (
        <KTSVG path='/media/icons/duotune/abstract/abs009.svg' className='svg-icon-1 text-success' />
      ) : (
        <KTSVG path='/media/icons/duotune/abstract/abs012.svg' className='svg-icon-1 text-danger' />
      )}
    </span>
    <div className='flex-grow-1 me-2 d-flex flex-column'>
      { inspection?.type &&
      <div className="d-flex flex-row gap-2 align-items-center fs-7 lh-sm">
        <div className="pt-0.5 text-muted">Type : </div>
        <div className="fw-bold">{inspection.type}</div>
      </div>
      }
      <div className="d-flex flex-row gap-6 align-items-center">
        <div className="flex-grow-1 d-flex flex-column gap-1">
          {(inspection?.testReportReference) &&
          <div className='flex-grow-1 fw-bold text-gray-800 text-hover-primary fs-7 lh-sm min-w-150px' style={{whiteSpace: 'pre-line'}}>
            {inspection.testReportReference}&nbsp;
          </div >
          }
          {(inspection?.samplings && isPopulatedArray(inspection.samplings)) &&
          <>
          { inspection.samplings.map((sobj, sidx) => (
            <div key={`sampl${sidx}`} className="w-100 d-flex flex-row gap-6 align-items-center">
              <div className='fw-bold text-gray-800 text-hover-primary fs-7 lh-sm min-w-125px' style={{whiteSpace: 'pre-line'}}>
                {sobj?.testReportReference ? sobj.testReportReference : ''}
              </div >
              {(sobj?.surveillanceTestResult) &&
              <div className="d-flex flex-row gap-2 align-items-center text-muted fw-semibold fs-8">
                <div className="pt-0.5">Surveillance Test Result : </div>
                <ApplicationFileDownload file={sobj.surveillanceTestResult} />
              </div>
              }
            </div>
          ))}
          </>
          }
        </div>
        <ShowDateCell date_val={inspection.dteCr} stack={true} />
      </div>
      <div className="d-flex flex-row justify-content-between">
        <div className='text-muted fw-semibold d-flex flex-row flex-wrap align-items-center gap-4 fs-8'>
          { inspection?.testDate &&
          <div className="d-flex flex-row gap-2 align-items-center">
            <div className="pt-0.5">Test Date : {`${inspection.testDate}`}</div>            
          </div>
          }
          {inspection.inspectionResult &&
          <div className="d-flex flex-row gap-2 align-items-center">
            <div className="pt-0.5">Completed Audit Kit : </div>
            <ApplicationFileDownload file={inspection.inspectionResult} />
          </div>
          }
          {inspection.samplingForm &&
          <div className="d-flex flex-row gap-2 align-items-center">
            <div className="pt-0.5">Sampling Form : </div>
            <ApplicationFileDownload file={inspection.samplingForm} />
          </div>
          }
          {inspection.ncr &&
          <div className="d-flex flex-row gap-2 align-items-center">
            <div className="pt-0.5">Non-Conformity Report : </div>
            <ApplicationFileDownload file={inspection.ncr} />
          </div>
          }
          {inspection.surveillanceTestResult &&
          <div className="d-flex flex-row gap-2 align-items-center">
            <div className="pt-0.5">Surveillance Test Result : </div>
            <ApplicationFileDownload file={inspection.surveillanceTestResult} />
          </div>
          }
          {inspection.completedInspectionCOC &&
          <div className="d-flex flex-row gap-2 align-items-center">
            <div className="pt-0.5">Completed Draft CoC : </div>
            <ApplicationFileDownload file={inspection.completedInspectionCOC} />
          </div>
          }
          {inspection.approved &&
          <div>Major Non-Conformance : { inspection.majorNCFound ? 'FOUND' : 'NONE'}</div>
          }
        </div>
        { (hasRole('CAMS Editor')) &&
        <div className='text-dark text-hover-danger w-80px text-center' title="Reupload Files" onClick={onClickReupload} >
          <KTSVG
            path='/media/icons/duotune/arrows/arr078.svg'
            className='svg-icon-3'
          />
        </div>
        }
      </div>
    </div>
  </div>
  )
}





